import React from "react";
import NavBar from '../components/navbar';
import LoginButton from '../components/login-button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { IconButton } from '@material-ui/core';
import { useAuth0 } from '@auth0/auth0-react';
import { makeStyles } from '@material-ui/core/styles';

import './Home.css';

const useStyles = makeStyles((theme) => ({
  iconBtn:{
    '& .MuiSvgIcon-root':{
      color:'#153BAB',
    },
    height:'50px',
    width:'50px',
  },
  icon:{
    height:'35px',
    width:'35px',
  },


}));

const JoinTalentNetwork = (props) => {
  const classes = useStyles();
  const { user, isAuthenticated } = useAuth0();
  // loading and error is not used 
  // const [loading, setLoading] = React.useState(true);
  // const [error, setError] = React.useState('');
  const [data, setData] = React.useState([]);
  console.log(process.env.REACT_APP_IP)


  React.useEffect(() => {
    // setLoading(true);
    if (isAuthenticated) {

      fetch(process.env.REACT_APP_IP + '/check/' + user.sub)
        .then((response) => response.json())
        .then((data) => {
          // setLoading(false);
          setData(data);
        })
        .catch((e) => {
          // setLoading(false);
          // setError('fetch failed');
          console.log('fetch failed');
        });
        console.log(data)
    }
  }, [isAuthenticated, user, data]);

  return (
    <div className="Home">
      <NavBar type="exam" />
      <br />
      <div className="home">
        {/* Lyra's Benefits */}
        <IconButton className={classes.iconBtn}><ArrowBackIcon className={classes.icon}/></IconButton>
        <section className="get-started" style={{marginTop:'-5rem' }}>
        
          <div style={{marginLeft:'5rem' }}>
            <h2 className="display-2" style={{ color: '#153BAB',}}>
            Want to land AI jobs, or elevate <br />
            your skills?
            </h2>
            <div>
              <h2 className="display-3" style={{ fontSize:'20px' ,fontWeight:'bold', color:'#505050',}}>
              Hone your AI abilities.
              </h2>
              <p className="display-3" style={{ fontSize:'15px' , color:'#505050', marginTop:'-10px'}}>
              Lyra will tailor a learning path for you &amp; our expert senior <br />
              consultants will provide you with continuous mentorship.
              </p>
            </div>
            <div>
              <h2 className="display-3" style={{ fontSize:'20px' ,fontWeight:'bold', color:'#505050',}}>
              Work on real projects.
              </h2>
              <p className="display-3" style={{ fontSize:'15px' , color:'#505050', marginTop:'-10px'}}>
              You'll be able to join global AI teams and work on exciting <br />
              remote projects.
              </p>
            </div>
            <div>
              <h2 className="display-3" style={{ fontSize:'20px' ,fontWeight:'bold', color:'#505050',}}>
              Secure the right AI job for you.
              </h2>
              <p className="display-3" style={{ fontSize:'15px' , color:'#505050', marginTop:'-10px'}}>
              If you qualify and meet requirements, our algorithms can <br />
              quickly match you with the right remote employer.
              </p>
            </div>
            <br /><br />
            <div className="Talent" style={{ display: 'inline-block',  marginRight:'8rem',}}>
                <center>
                <LoginButton txt="Join Talent Network" />
                </center>
            </div>

          </div>
        </section>

      </div>

      <div style={{ marginTop: '50px' }}>
      </div>
    </div>
  );
}


export default JoinTalentNetwork;
